import { BulletpointsProductModel, ExtraLinksProductModel, InfotextProductModel, LogoProductModel, WebshopProductModel } from "models/WebShop";

export const getPayloadString = (product: WebshopProductModel): string => {
    if (isLogoProduct(product)) {
      return JSON.stringify({ img: product.img });
    } else if (isBulletpointsProduct(product)) {
      return JSON.stringify({ bulletpoints: product.bulletpoints });
    } else if (isInfotextProduct(product)) {
      return JSON.stringify({ infotext: product.infotext });
    } else if (isExtraLinksProduct(product)) {
      return JSON.stringify({ extraLinks: product.extraLinks });
    } else {
      return "";
    }
  };

  export function isLogoProduct(product: WebshopProductModel): product is LogoProductModel {
    return (product as LogoProductModel).img !== undefined;
  }

  export function isBulletpointsProduct(product: WebshopProductModel): product is BulletpointsProductModel {
    return (product as BulletpointsProductModel).bulletpoints !== undefined;
  }

 export function isInfotextProduct(product: WebshopProductModel): product is InfotextProductModel {
    return (product as InfotextProductModel).infotext !== undefined;
  }

 export function isExtraLinksProduct(product: WebshopProductModel): product is ExtraLinksProductModel {
    return (product as ExtraLinksProductModel).extraLinks !== undefined;
  }